import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import ActionLink from 'components/buttons/action-link/ActionLink';
import ManagedByTag from 'components/managed-by-tag/ManagedByTag';
import FormRequiredMark from 'components/form/form-required-mark/FormRequiredMark';
import CroppedProfileImage from 'components/cropped-profile-image/CroppedProfileImage';
import ChannelsIcons from 'modules/influencers/components/ChannelIcons';

import { t } from 'utils/language';
import { getManagedByBrand } from 'utils/profile';

class ProfileSummary extends Component {
  static propTypes = {
    canEdit: PropTypes.bool.isRequired,
    profile: PropTypes.object,
    sendImage: PropTypes.func,
    coverImageType: PropTypes.string,
    children: PropTypes.any
  };

  static defaultProps = {
    coverImageType: 'cover'
  };

  handleCoverImageChanged = (image) => {
    const { sendImage } = this.props;

    if (sendImage) {
      return sendImage('cover', image);
    }

    return Promise.resolve();
  };

  handleProfileImageChanged = (image) => {
    const { sendImage } = this.props;

    if (sendImage) {
      return sendImage('profile', image);
    }

    return Promise.resolve();
  };

  renderRequiredMark(imageType) {
    return (
      <div className="profile-summary__image-required profile-summary__image-required--create">
        {t(`profile_required_${imageType}_image`)}
        <FormRequiredMark />
      </div>
    );
  }

  renderSummary() {
    const { profile, coverImageType, canEdit } = this.props;
    const managedByBrand = getManagedByBrand(profile);

    const infoClasses = classnames({
      'profile-summary__info': true,
      'profile-summary__info--create': canEdit,
      'profile-summary__info--floating': !canEdit
    });

    return (
      <section className="profile-summary">
        <CroppedProfileImage
          image={profile.coverImage}
          canEdit={canEdit}
          type={coverImageType}
          onChange={this.handleCoverImageChanged}
          data={{ qa: 'profile-summary__cover-image' }}
        />
        {
          canEdit &&
            this.renderRequiredMark('cover')
        }
        <div className={infoClasses}>
          <div className="profile-summary__info-image">
            <CroppedProfileImage
              image={profile.profileImage}
              canEdit={canEdit}
              type="profile"
              onChange={this.handleProfileImageChanged}
              data={{ qa: 'profile-summary__profile-image' }}
            />
            {
              canEdit &&
                this.renderRequiredMark('profile')
            }
          </div>
          <div className="profile-summary__info-data">
            <div className="profile-summary__info-content profile-summary__info-content--centered profile-summary__info-content--full-width">
              <div className="profile-summary__title">
                <h1
                  className="profile-summary__name text-overflow-wrap"
                  data-qa="profile-summary__name"
                >
                  {profile.name}
                </h1>
                {
                  !canEdit && (
                    <div className="profile-summary__brand-managed-by-tag-name">
                      <ManagedByTag managedByBrand={managedByBrand} />
                    </div>
                  )
                }
              </div>
              {
                profile.url &&
                  <div className="text-overflow-ellipsis">
                    <ActionLink
                      size="medium"
                      color="light"
                      link={profile.url}
                      data={{ qa: 'brand-profile-url' }}
                    >
                      {profile.url.replace(/^http(s)?:\/\//, '')}
                    </ActionLink>
                  </div>
              }
            </div>
          </div>
          <div className="profile-summary__info-reach">
            <ChannelsIcons
              channels={[
                {
                  type: 'instagram',
                  url: profile.instagramUrl
                },
                {
                  type: 'youtube',
                  url: profile.youtubeUrl
                }
              ]}
            />
          </div>
        </div>
      </section>
    );
  }

  render() {
    const { children } = this.props;
    return (
      <div className="brand-profile__summary">
        {this.renderSummary()}
        {children}
      </div>
    );
  }
}

export default ProfileSummary;
